let counter = 0;

// We don't need a uuid a simple number would suffice
export const v4 = () => `__windowsId__${counter++}`;
